import { RecommendationType, ValueReferences } from './enums';

export const formatBalance = (value: number | null, minimumFractionDigits?: number, maximumFractionDigits?: number): string => {
    if (value !== null) {
        if (value === 0) {
            return '+/- 0';
        }

        const formattedBalance = new Intl.NumberFormat('en-US', {
            minimumFractionDigits,
            maximumFractionDigits,
            signDisplay: 'exceptZero',
        }).format(value);

        return formattedBalance;
    }

    return ValueReferences.NA;
};

export const formatCurrency = (value: number | null | undefined, minimumFractionDigits: number = 2, maximumFractionDigits: number = 2): string => {
    if (value !== undefined && value !== null) {
        const formattedCurrency = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits,
            maximumFractionDigits,
        }).format(value);

        return formattedCurrency;
    }

    return ValueReferences.NA;
};

export const formatNumber = (value: number | null | undefined, minimumFractionDigits: number = 0, maximumFractionDigits: number = 0): string => {
    if (value !== undefined && value !== null) {
        const formattedNumber = new Intl.NumberFormat('en-US', {
            minimumFractionDigits,
            maximumFractionDigits,
        }).format(value);

        return formattedNumber;
    }

    return ValueReferences.NA;
};

export const formatNumberPercent = (
    value: number | null | undefined,
    minimumFractionDigits: number = 0,
    maximumFractionDigits: number = 0,
    signDisplay: 'auto' | 'never' | 'always' | 'exceptZero' | undefined = undefined
): string => {
    if (value !== undefined && value !== null) {
        const formattedNumber = new Intl.NumberFormat('en-US', {
            minimumFractionDigits,
            maximumFractionDigits,
            signDisplay,
        }).format(value);

        return `${formattedNumber}%`;
    }

    return ValueReferences.NA;
};

/**
 * Formats the given number to turn 1 into 1st
 * @param value Number to be formatted
 * @returns Formatted rank
 */
export const formatRank = (value: number | null): string => {
    if (value === null) {
        return ValueReferences.NA;
    }

    const j = value % 10;
    const k = value % 100;

    if (j === 1 && k !== 11) {
        return `${value}st`;
    }

    if (j === 2 && k !== 12) {
        return `${value}nd`;
    }

    if (j === 3 && k !== 13) {
        return `${value}rd`;
    }

    return `${value}th`;
};

/**
 * Converts hour to a timestring in hours and minutes
 * @param timeStr hours to format
 */
export const formatTime = (timeStr: string | null): string | null => {
    if (timeStr === null) {
        return null;
    }

    const timeInHours = parseFloat(timeStr);
    const hrs = Math.floor(timeInHours);
    const mins = Math.round((timeInHours * 60) % 60);
    return `${hrs}:${mins}`;
};

export const truncateId = (id: string): string => {
    if (id.length > 20) {
        return `${id.slice(0, 20)}...`;
    }

    return id;
};

export const formatRecommendationType = (type?: RecommendationType): string => {
    if (type === undefined) {
        return ValueReferences.NA;
    }

    const typeLookup: Record<RecommendationType, string> = {
        move_more_freight: 'Move More Freight',
        move_less_freight: 'Move Less Freight',
        start_service: 'Start Service',
        stop_service: 'Stop Service',
    };

    return typeLookup[type];
};
